import { FC } from "react";

const GooglePlayLogo: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="28"
      viewBox="0 0 26 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.495667 0.429355C0.180911 0.767644 0 1.28831 0 1.96489V26.0305C0 26.7071 0.180911 27.2277 0.507434 27.5543L0.592741 27.6263L14.0772 14.1418V13.8388L0.580975 0.357285L0.495667 0.429355Z"
        fill="url(#paint0_linear_167_18174)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5631 18.6543L14.0654 14.1551V13.8403L18.5646 9.34109L18.6617 9.4014L23.9831 12.4254C25.5069 13.2844 25.5069 14.6993 23.9831 15.57L18.6617 18.594C18.6602 18.594 18.5631 18.6543 18.5631 18.6543Z"
        fill="url(#paint1_linear_167_18174)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6603 18.594L14.0654 13.9977L0.495605 27.5675C0.991272 28.0999 1.82523 28.1602 2.75773 27.6395L18.6603 18.594Z"
        fill="url(#paint2_linear_167_18174)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6603 9.40286L2.75773 0.369069C1.8267 -0.163369 0.991272 -0.0912986 0.495605 0.441139L14.0639 13.9977L18.6603 9.40286Z"
        fill="url(#paint3_linear_167_18174)"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5629 18.497L2.76926 27.4705C1.88677 27.9779 1.09988 27.9426 0.592449 27.4822L0.507141 27.5675L0.592449 27.6396C1.09988 28.0985 1.88677 28.1353 2.76926 27.6278L18.6718 18.5941L18.5629 18.497Z"
        fill="black"
      />
      <path
        opacity="0.12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9815 15.4126L18.5512 18.4969L18.6483 18.594L23.9697 15.57C24.7316 15.1346 25.1067 14.5669 25.1067 13.9977C25.0582 14.5183 24.6713 15.014 23.9815 15.4126Z"
        fill="black"
      />
      <path
        opacity="0.25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75779 0.526432L23.9818 12.5842C24.6716 12.9711 25.0584 13.4785 25.1187 13.9992C25.1187 13.4314 24.7436 12.8622 23.9818 12.4269L2.75779 0.369054C1.23402 -0.501672 0 0.223443 0 1.9649V2.12227C0 0.380821 1.23402 -0.332528 2.75779 0.526432Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_167_18174"
          x1="12.8664"
          y1="1.70621"
          x2="-8.73344"
          y2="7.46151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.007" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.512" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_167_18174"
          x1="25.966"
          y1="13.9984"
          x2="-0.370441"
          y2="13.9984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.409" stopColor="#FFBD00" />
          <stop offset="0.775" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_167_18174"
          x1="16.1617"
          y1="16.4981"
          x2="-1.17872"
          y2="45.6831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_167_18174"
          x1="-2.92025"
          y1="-7.57601"
          x2="4.81584"
          y2="5.45851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.069" stopColor="#2DA771" />
          <stop offset="0.476" stopColor="#15CF74" />
          <stop offset="0.801" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GooglePlayLogo;
